import { render } from "./Foot.vue?vue&type=template&id=c293a5e6&scoped=true"
import script from "./Foot.vue?vue&type=script&lang=js"
export * from "./Foot.vue?vue&type=script&lang=js"

import "./Foot.vue?vue&type=style&index=0&id=c293a5e6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c293a5e6"

export default script